var map = {
	"./CSS.webp": 212,
	"./CodingLab.webp": 213,
	"./HTML.webp": 214,
	"./HTML_JS_CSS.webp": 215,
	"./Hopscotch.webp": 216,
	"./JS.webp": 217,
	"./LegoWedo.webp": 218,
	"./MicroBit.webp": 219,
	"./Python.webp": 220,
	"./Scratch.webp": 221,
	"./ScratchJr.webp": 222,
	"./SpheroEdu.webp": 223,
	"./Tynker.webp": 224,
	"./TynkerJr.webp": 225,
	"./WonderBlockly.webp": 226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;